import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const SimilarHotelsLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};

`,
);

export const SimilarHotelsLoaderInnerWrapDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goYellow.light};
  width: 100%;
  padding:${props.theme.spacing.large};
`,
);

export const SimilarHotelsLoaderInnerWrapbgWhiteDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goWhite.base};

`,
);

export const SimilarHotelsLoaderHeaderDiv = styled.div(
  props => `

  padding:${props.theme.spacing.large};
  background-color:${props.theme.colors.goBrandBlue.medium};
  justify-content: space-between;
  margin-bottom:${props.theme.spacing.large};
  width:16.7rem;
  height:2.5rem;

`,
);

export const SimilarHotelsImageDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.base};
  margin-bottom:${props.theme.spacing.base};
  width:25.8rem;
  height:16.7rem;

`,
);

export const HotelsImageTitleDiv = styled.div(
  props => `

  padding:${props.theme.spacing.large};
  background-color:${props.theme.colors.goBrandBlue.medium};
  justify-content: space-between;
  margin-bottom:${props.theme.spacing.base};
  width:12.2rem;
  height:1.8rem;

`,
);

export const HotelsSubTitleWrapDiv = styled.div(
  props => `

  border-top: 1px solid ${props.theme.colors.goBrandBlue.light};
  border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};
  padding-top: ${props.theme.spacing.base};
  margin-bottom:${props.theme.spacing.base};
`,
);

export const HotelsSubTitleDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.base};
  margin-bottom:${props.theme.spacing.base};
  width:21.8rem;
  height:1.8rem;

`,
);

export const HotelsSmallTextDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.base};
  margin-bottom:${props.theme.spacing.small};
  width:7.1rem;
  height:1.8rem;

`,
);
